export const TIPOS_CORRENTE_CARREGADOR = [
  { value: "CA", label: "CA — corrente alternada" },
  { value: "CC", label: "CC — corrente contínua" },
] as const;

export type TipoCorrenteCarregador = (typeof TIPOS_CORRENTE_CARREGADOR)[number]["value"];

export function labelTipoCorrenteCarregador(tipo: TipoCorrenteCarregador): string {
  switch (tipo) {
    case "CA":
      return "CA";
    case "CC":
      return "CC";
    default: {
      const _nunca: never = tipo;
      return _nunca;
    }
  }
}

export interface ModeloCarregadorVeicular {
  id: string;
  marca: string;
  modelo: string;
  codigo: string | null;
  tipoCorrente: TipoCorrenteCarregador;
  modoRecarga: string | null;
  potenciaNominalKw: number;
  potenciaNominalTexto: string | null;
  tensaoEntrada: string | null;
  correnteEntrada: string | null;
  frequencia: string | null;
  conexaoEletrica: string | null;
  tensaoSaida: string | null;
  correnteSaida: string | null;
  fatorPotencia: string | null;
  eficiencia: string | null;
  tipoConector: string | null;
  quantidadeConectores: number | null;
  comprimentoCabo: string | null;
  interfaceUsuario: string | null;
  modoInicio: string | null;
  comunicacao: string | null;
  protocolo: string | null;
  medidorEnergia: string | null;
  grauProtecao: string | null;
  protecaoImpacto: string | null;
  protecoesEletricas: string | null;
  normas: string | null;
  temperaturaOperacao: string | null;
  umidadeOperacao: string | null;
  altitudeOperacao: string | null;
  dimensoes: string | null;
  pesoKg: number | null;
  materialInvolucro: string | null;
  instalacao: string | null;
  garantiaMeses: number | null;
  observacoes: string | null;
  datasheetUrl: string | null;
  imagemUrl: string | null;
  imagemUrl2: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateModeloCarregadorVeicular {
  marca: string;
  modelo: string;
  codigo: string | null;
  tipoCorrente: TipoCorrenteCarregador;
  modoRecarga: string | null;
  potenciaNominalKw: number;
  potenciaNominalTexto: string | null;
  tensaoEntrada: string | null;
  correnteEntrada: string | null;
  frequencia: string | null;
  conexaoEletrica: string | null;
  tensaoSaida: string | null;
  correnteSaida: string | null;
  fatorPotencia: string | null;
  eficiencia: string | null;
  tipoConector: string | null;
  quantidadeConectores: number | null;
  comprimentoCabo: string | null;
  interfaceUsuario: string | null;
  modoInicio: string | null;
  comunicacao: string | null;
  protocolo: string | null;
  medidorEnergia: string | null;
  grauProtecao: string | null;
  protecaoImpacto: string | null;
  protecoesEletricas: string | null;
  normas: string | null;
  temperaturaOperacao: string | null;
  umidadeOperacao: string | null;
  altitudeOperacao: string | null;
  dimensoes: string | null;
  pesoKg: number | null;
  materialInvolucro: string | null;
  instalacao: string | null;
  garantiaMeses: number | null;
  observacoes: string | null;
  datasheetUrl?: string | null;
  imagemUrl?: string | null;
  imagemUrl2?: string | null;
}

export type UpdateModeloCarregadorVeicular = Partial<CreateModeloCarregadorVeicular>;

export function nomeExibicaoModeloCarregador(item: { marca: string; modelo: string }): string {
  return `${item.marca} ${item.modelo}`.trim();
}
